import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { PM_ServiceService } from 'src/app/Service/PM/PM_Service.service';

@Component({
  selector: 'app-PMServiceHistory',
  templateUrl: './PMServiceHistory.component.html',
  styleUrls: ['./PMServiceHistory.component.scss']
})
export class PMServiceHistoryComponent implements OnInit {

  @Input() inner_DeviceBehfa: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()
  @Output() OnBack_DeviceBehfa_Action = new EventEmitter<number>();

  Token: string = ""
  Filter_Title: string = ""
  Filter_Description:string=''
  Filter_Manufacturer:string=''
  Filter_Model:string=''
  Filter_Code:string=''

  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private PM_Service_Service: PM_ServiceService,
    public router: Router,
  ) { }


  DataList_PM: Array<PM_Service_Interface> = []



  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_PM()
  }

  OnSet_Back_DeviceBehfa(){
    this.OnBack_DeviceBehfa_Action.emit(-1);
  }

  ReadData_PM() {
    this.Procssing = true
    this.PM_Service_Service.GetHistory(this.inner_DeviceBehfa.id,this.Token).subscribe(
      data => {
        this.DataList_PM = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  Change_Filter() {
    this.page = 0
  }

}
